
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3687_43250)"}},[_c('path',{attrs:{"d":"M15.5 8.04584C15.5 3.87838 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.87838 0.5 8.04584C0.5 11.8121 3.24263 14.9339 6.82812 15.5V10.2271H4.92383V8.04584H6.82812V6.38339C6.82812 4.49222 7.94785 3.44759 9.66099 3.44759C10.4813 3.44759 11.3398 3.59497 11.3398 3.59497V5.45195H10.3941C9.4625 5.45195 9.17188 6.03366 9.17188 6.63099V8.04584H11.252L10.9194 10.2271H9.17188V15.5C12.7574 14.9339 15.5 11.8121 15.5 8.04584Z","fill":"#10001F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3687_43250"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"white","transform":"matrix(-1 0 0 1 16 0)"}})])])])
          )
        }
      }
    